<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Communication Detail</h1>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">Communication Overview</div>
          <div class="card-body">
            <div v-show="is_loading">
              <skeleton-box
                height="30px"
                width="100%"/>
              <skeleton-box
                class="mt-3"
                height="30px"
                width="100%"/>
              <skeleton-box
                class="mt-3"
                height="30px"
                width="100%"/>
            </div>
            <div v-show="!is_loading">
              <p class="m-0 font-weight-bold">Communication Overview</p>
              <p class="m-0">Type: {{ communication_data.communication_type.name }}</p>
              <p class="m-0">Method: {{ communication_data.communication_method.name }}</p>
              <p class="m-0">Date: {{ communication_data.date.format('DD MMMM YYYY') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mt-3" v-if="communication_data.communication_type.name != 'Blast'">
        <div class="card">
          <div class="card-header">Recipient Information</div>
          <div class="card-body">
            <div v-show="is_loading">
              <skeleton-box
                height="30px"
                width="100%"/>
              <skeleton-box
                class="mt-3"
                height="30px"
                width="100%"/>
              <skeleton-box
                class="mt-3"
                height="30px"
                width="100%"/>
            </div>
            <div v-show="!is_loading">
              <div v-if="communication_data.communication_type.name == 'Personal'">
                <p class="m-0">{{ communication_data.user != null ? communication_data.user.name : communication_data.mitra.name }}</p>
                <p class="m-0">{{ communication_data.user != null ? communication_data.user.phone_number : communication_data.mitra.phone_number }}</p>
                <p class="m-0">{{ communication_data.user != null ? communication_data.user.email : communication_data.mitra.email }}</p>
              </div>
              <div v-else-if="communication_data.communication_type.name == 'Helper category / sub category'">
                <p class="m-0">{{ communication_data.helper_sub_category.name }}</p>
              </div>
              <div v-else-if="communication_data.communication_type.name == 'User Type'">
                <p class="m-0">{{ communication_data.type.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mt-3">
        <div class="card">
          <div class="card-header">Communication Message</div>
          <div class="card-body">
            <div v-show="is_loading">
              <skeleton-box
                class="mt-3"
                height="30px"
                width="100%"/>
              <skeleton-box
                class="mt-3"
                height="30px"
                width="100%"/>
            </div>
            <div v-show="!is_loading">
              <p class="m-0">Subject: {{ communication_data.subject }}</p>
              <p class="m-0" v-html="'Message: '+communication_data.message"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'

export default{
  components:{
    'skeleton-box': SkeletonBox,
  },
  data(){
    return{
      communication_data: {
        communication_type: {
          name: ''
        },
        communication_method: {
          name: ''
        },
        date: moment(),
        subject: '',
        message: '',
        type: {
          name: '',
        },
        user: {
          name: '',
          phone: '',
          email: '',
        },
      },
      is_loading: true
    }
  },
  async created(){
    await this.get_data()
    this.is_loading = false
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/communication?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          response_data.data.date = moment(response_data.data.created_at)
          console.log(response_data.data)
          this.communication_data = response_data.data
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
